var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueSimpleEmbed',{staticClass:"has-text-centered",attrs:{"attrs":{
      class: 'mw-full mx-auto',
      width: '728',
      height: '546'
    },"extra-data":_vm.data,"parser":_vm.type,"url":_vm.data.url},scopedSlots:_vm._u([{key:"caption",fn:function(){return [(_vm.data.caption)?_c('p',{staticClass:"mt-3 has-text-centered is-size-8"},[_vm._v(" "+_vm._s(_vm.data.caption)+" ")]):_vm._e()]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }